import _ from 'lodash'
import { ResponseArray } from '../types'
import { ICustomer, IAddress, ICustomerSearchFilter } from './types'
import { blankResponseArray } from '../constants'

export const blankAddress: IAddress = {
  Name1: '',
  Street: '',
  Name2: '',
  City: '',
  Region: '',
  PostalCode: '',
  Phone: '',
  Country: 'US',
  Emails: [],
  FirstName: '',
  LastName: '',
}

export const blankCustomer: ICustomer = {
  CustomerNumber: '',
  CustomerName: '',
  CustomerSalesText: [],
  CustomerShippingText: [],
  CustomerAddress: blankAddress,
  Orders: [],
  PendingPermissionRequests: [],
  Permissions: [],
  SalesReps: [],
  PaymentTerm: '',
}

export const blankSearchFilters: ICustomerSearchFilter =
{
  page: 1,
  pageSize: 30,
  sortBy: 'PermissionRequests',
  sortDesc: true,
  customerName: '',
  customerNumber: '',
  filterByHasUsers: false,
  filterByHasPendingPermissions: false,
  city: '',
  state: '',
  postalCode: '',
}

export const blankSalesRepArray: ResponseArray<ICustomer> = _.assign(
  [],
  blankResponseArray,
)
